<template>
    <div>
        <ContactUsTop />
        <div class="contactInformation">
            <div class="titleStyle">
                <div class="titleFont">联系我们</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">CONTACT US</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="contactInformationList">
                <div
                    class="contactInformationItem"
                    v-for="(item, idx) in listInfo"
                    :key="idx"
                >
                    <div class="itemFont">
                        <div class="itemTitle">{{ item.title }}</div>
                        <div class="itemContent itemTel">
                            {{ item.tel }}
                        </div>
                        <div class="itemContent itemAddress">
                            {{ item.address }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ContactUsTop from "@/components/ContactUsTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "ContactInformation",
    components: {
        ContactUsTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsContactus/queryPageList",
            total: undefined,
            listInfo: [],
        };
    },
    created() {
        this.getListInfo();
    },
    methods: {
        getListInfo() {
            let that = this;
            getAction(that.url).then((res) => {
                if (res.code == 200 && res.success) {
                    that.listInfo = res.result.records;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.contactInformation {
    background: #fbfbfb;
    .contactInformationList {
        .typeArea();
        padding-bottom: 70px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .contactInformationItem {
            margin-bottom: 20px;
            width: 353px;
            height: 280px;
            background-color: #ffffff;
            border: solid 1px #e1e1e1;
            display: flex;
            align-items: center;
            justify-content: center;
            .itemFont {
                width: 100%;
                padding: 40px 20px; 
                .itemTitle {
                    font-size: 22px;
                    margin-bottom: 60px;
                    font-family: "黑体";
                    line-height: 28px;
                    color: #333333;
                }
                .itemContent {
                    font-size: 18px;
                    color: #333333;
                }
                .itemTel{
                    margin-bottom: 28px;
                    background: url('../../assets/contactUs/tel.png') no-repeat;
                    padding-left: 40px;
                    background-position: 0 50%;
                }
                .itemAddress{
                    background: url('../../assets/contactUs/address.png') no-repeat;
                    padding-left: 40px;
                    background-position: 0 0;
                }
            }
        }
        .contactInformationItem:hover {
            box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.2);
        }
    }
}
</style>